import axios from 'axios';
import router from './router';
import store from './store';

const axiosConfig = {};

axiosConfig.baseURL = process.env.VUE_APP_BASE_URL;

const AxiosInstance = axios.create(axiosConfig);

AxiosInstance.defaults.headers.common.Accept = 'application/json';

AxiosInstance.interceptors.request.use(
  (config) => {
    if (!config.skipLoading) {
      store.commit('increaseLoadingCounter');
    }
    return config;
  },
  error => Promise.reject(error),
);

AxiosInstance.interceptors.response.use(
  (response) => {
    if (!response.config.skipLoading) {
      store.commit('decreaseLoadingCounter');
    }
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      store.dispatch('auth/logout').then(() => {
        router.push('/login');
      });
    }
    store.dispatch('auth/losted_auth', { error });
    if (error.config && !error.config.skipLoading) {
      store.commit('decreaseLoadingCounter');
    }
    return Promise.reject(error);
  },
);

export default AxiosInstance;
